import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const queryParams = new URLSearchParams(window.location.search);
if(queryParams.get('supervisortoken')){
  window.$crisp.push(["do", "session:reset"])
  localStorage.clear()
  localStorage.setItem('token', queryParams.get('supervisortoken'))
  if(queryParams.get('viewer'))
    window.location = '/#/dash/planner'
  else  
    window.location = '/'
}

if (!localStorage.token && ['post_id', 'page_id'].every(p => (queryParams).has(p)))
  localStorage.setItem('redirect_params_url', window.location.href)

export default new Router({
  routes: [
    {
      name: 'underscore',
      path: '/_',
      redirect: '/dash/overview',
      component: () => import('@/views/Dash'),
      beforeEnter: (_to, _from, next) => {
        if (!localStorage.token)
          return next({ name : 'auth' })

        next()
      }
    },
    {
      name: 'dash',
      path: '/dash',
      redirect: '/dash/overview',
      component: () => import('@/views/Dash'),
      beforeEnter: (_to, _from, next) => {
        if (!localStorage.token)
          return next({ name : 'auth' })

        next()
      },
      children: [
        {
          path: 'overview',
          name: 'overview',
          component: () => import('@/components/dash/section/Overview')
        },
        {
          path: 'pages',
          name: 'pages',
          component: () => import('@/components/dash/section/Pages')
        },
        {
          path: 'bots',
          name: 'bots',
          component: () => import('@/components/dash/section/Bots'),
          props: true,
          alias: ['bots/new', 'bots/edit']
        },
        {
          path: 'posts',
          name: 'posts',
          component: () => import('@/components/dash/section/Posts'),
          props: true,
        },
        {
          path: 'planner',
          name: 'planner',
          component: () => import('@/components/dash/section/Posts'),
          props: true
        },
        {
          path: 'moderation',
          name: 'moderation',
          component: () => import('@/components/dash/section/Moderation'),
          props: true
        },
        {
          path: 'settings/:tab?',
          name: 'settings',
          component: () => import('@/components/dash/section/Settings'),
          alias: ['settings/users', 'settings/user']
        },
        {
          path: 'invoice',
          name: 'invoice',
          component: () => import('@/components/dash/section/Invoice')
        },
        {
          path: 'sources',
          name: 'sources',
          component: () => import('@/components/dash/section/Sources')
        },
        {
          path: 'reporting',
          name: 'reporting',
          component: () => import('@/components/dash/section/Reporting')
        },
        {
          path: 'plan',
          name: 'plan',
          component: () => import('@/components/dash/section/Plan')
        },
        {
          path: 'postCreator',
          name: 'postCreator',
          component: () => import('@/components/dash/section/PostCreator'),
          props: { 
            mode: 'create',
            tab: 'standard'
          }, // Définit le mode par défaut comme 'create'
        },
        {
          path: 'postCreator/:mode',
          name: 'postCreator',
          component: () => import('@/components/dash/section/PostCreator'),
          props: true
        },
      ]
    },
    {
      name: 'auth',
      path: '/',
      component: () => import('@/views/Auth'),
      beforeEnter: (_to, _from, next) => {
        if (localStorage.token)
          return next({ name : 'dash' })

        next()
      },
      children: [
        {
          path: 'confirm',
          name: 'confirm'
        }
      ]
    },
    {
      name: 'invite',
      path: '/invite',
      redirect: '/',
      component: () => import('@/views/Invite'),
      children: [
        {
          path: 'shared-planner',
          name: 'shared-planner',
          component: () => import('@/components/dash/section/SharedPlanner')
        },
        {
          path: 'viewer',
          name: 'viewer',
          component: () => import('@/components/dash/section/ViewerLogin')
        }
      ]
    },
    {
      name: 'legal',
      path: '/',
      redirect: '/',
      component: () => import('@/views/Invite'),
      children: [
        {
          path: 'legal',
          name: 'legal',
          component: () => import('@/components/dash/section/Legal')
        }
      ]
    }
  ]
})
